<!--
 * @Author: your name
 * @Date: 2021-04-13 13:20:57
 * @LastEditTime: 2021-06-23 15:56:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\views\home\components\sidebar\SidebarItem.vue
-->
<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link :to="resolvePath(onlyOneChild.permisUrl)">
        <el-menu-item :index="resolvePath(onlyOneChild.permisUrl)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.icon||item.icon" :title="onlyOneChild.permisName" :isCollapse="isCollapse"/>
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="resolvePath(item.permisUrl)" popper-append-to-body>
      <template slot="title">
        <item :icon="item.icon" :title="item.permisName" :isCollapse="isCollapse"/>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.permisUrl"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.permisUrl)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/common/utils/validate'
import Item from './Item'
import AppLink from './Link'
import { mapState } from 'vuex'
export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  computed: {
    ...mapState(['isCollapse'])
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      if (!children) {
        children = [];
      }
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // if (showingChildren.length === 1) {
      //   return true
      // }

      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (routePath && isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      // return path.resolve(this.basePath, routePath)
      return routePath ? '/' + routePath : ''
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/home/components/EcMenu/SidebarItem.vue